<script setup lang="ts">
import type { DetectionModel } from '@/types/models/DetectionModel'
import { IconItem } from '@rfc/rfc-components-library'
import {
    defaultThemeProvider,
    EColors,
    EProviders,
    type ThemeProviderType
} from '@rfc/rfc-components-library/types'
import { inject } from 'vue'

const { theme } = inject<ThemeProviderType>(EProviders.THEME, defaultThemeProvider)

type Props = DetectionModel
defineProps<Props>()
</script>

<template>
    <IconItem
        v-if="!!withdrawal"
        :type="theme === EColors.DARK ? EColors.WHITE : EColors.BLACK"
        icon="flag" />
</template>
